import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
      position: 'absolute',
      padding: 15,
      bottom: 60,
      right: 60,
      zIndex: 1000,
      width: 400,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[12],
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    header: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    headerControls: {
      display: 'flex',
      alignItems: 'center',
    },
    player: {
      width: '100%',
      display: 'flex',
      marginTop: 15,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }))

export default useStyles
